export const semarc = {
    agencyCode: '000701',
    name: 'Search Engine for Multi Agency Reportable Conduct',
    shortName: 'semarc',
    slug: 'semarc',
  };